/*Generated from the `:::slide{key="0a39f5a3-9965-40aa-863a-ec43819ce7cb" slug="polyphonic-characters"}` (simplified/001-P1/003/干.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "Ok, that's enough syllables for a while—back to tones!",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["Remember 干 (gàn)? It's actually a ", _jsx(html.strong, {
          children: "polyphonic",
          components: html
        }), " character, meaning it has more than one pronunciation."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["In addition to ", _jsx(html.em, {
          children: "gàn",
          components: html
        }), " (\"to do\"), 干 can also be pronounced with a high tone: ", _jsx(html.em, {
          children: "gān",
          components: html
        }), " (\"dry\")."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["How do you know how it's ", _jsx(html.em, {
          children: "read",
          components: html
        }), " while you ", _jsx(html.em, {
          children: "read",
          components: html
        }), " it? Just like you did with the word \"read\"—from context."]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
